<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Analisis Información - Financiación de Vivienda</h5>
    </div>
    <div class="card-body">
      <div class="row" style="margin-top: 3px;">
        <div class="col-auto" style="text-align: center;">
          <button type="button" class="btn btn-secondary" (click)="regresarAnalisis()">Volver</button>
        </div>
        <div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="anio" (change)="peridoPorAnioMes()" [(ngModel)]="anioConsulta"><!--     [disabled]="btnGuardar"-->
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
          </select>
        </div>
        <div class="col-auto">
          <label for=""><b>-</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="trimestre" (change)="peridoPorAnioMes()" [(ngModel)]="consucutivoConsulta" ><!-- [(ngModel)]="PeriodoConsulta"   [disabled]="btnGuardar"-->
            <option value="" selected="selected">Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
      <br>
      <div class="row" style="margin-top: 8px; margin-left: 0px;">
        <button type="button" class="btn btn-secondary col-auto" (click)="PreguntarTipoInformacionFichaGeneral()">Ver ficha analisis general</button>
      </div>
      <div id="tabla" class="container-fluid overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
           id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">Periodo</th>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón social</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Municipio</th>
              <th scope="col" class="text-center">Estado fuente</th>
              <th scope="col" class="text-center">Novedad</th>
              <th scope="col" class="text-center">Verificar</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let L of ListaEstadosFuentes">
              <td scope="col" >{{L.perido}}</td>
              <td scope="col" >{{L.nit}}</td>
              <td scope="col" >{{L.razonSocial}}</td>
              <td scope="col" >{{L.depto}}</td>
              <td scope="col" >{{L.muni}}</td>
              <td scope="col" >{{L.estado}}</td>
              <td scope="col" >{{L.novedad}}</td>
              <td scope="col" class="text-center" id="opciones">
                <a *ngIf="L.estado=='Cargado'" type="button" class="fa fa-chevron-circle-right" style="color: green; margin: 2px;" (click)="PreguntarTipoInformacionFichaIndividual(L.idfuente)"></a>
                <a *ngIf="L.estado=='Aprobado'" type="button" class="fa fa-chevron-circle-right" style="color: blue; margin: 2px;" (click)="PreguntarTipoInformacionFichaIndividual(L.idfuente)"></a>
                <a *ngIf="L.estado=='Pendiente'||L.estado=='En cargue'||L.estado=='En Proceso'" type="button" class="fa fa-chevron-circle-right" style="color: gray;  margin: 2px;  margin: 2px;"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<!--MODAL PREGUNTA FICHA ANALISIS GENERAL MENSUAL O TRIMESTRAL-->
<button class="btn btn-primary btn-sm" #OpenModalPreguntaFichaGeneral data-toggle="modal"  data-target="#modal-preguntageneral" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-preguntageneral" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modal" style="color: white;">Ficha de Analisis General</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #CloseModalPreguntaFichaGeneral>
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <div class="row" style="margin: auto;">
            <div class="col">
              <p>Desea que la <b>ficha de análisis general</b> se formule con información: </p>
            </div>
          </div>
          <div class="row" style="margin: auto;">
            <div class="col">
              <div class="row">
                <div class="col-auto"><b>Mensual</b></div>
                <div class="col-auto"><input class="form-check-input" type="checkbox" id="men" [(ngModel)]="MensualGeneral" [disabled]="TrimestralGeneral"></div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto"><b>Trimestral</b></div>
                <div class="col-auto"><input class="form-check-input" type="checkbox" id="tri" [(ngModel)]="TrimestralGeneral" [disabled]="MensualGeneral"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        <button type="button" class="btn btn-secondary" (click)="VerificarTipoInformacionFichaGeneral()">Aplicar</button>
      </div>
    </div>
  </div>
</div>

<!--FICHA DE ANALISIS GENERAL-->
<button class="btn btn-primary btn-sm" #OpenModalFichaGeneral data-toggle="modal"  data-target="#fichageneral" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-fullscreen" id="fichageneral" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
<div class="modal-dialog modal-fullscreen">
  <div class="modal-content">
    <div class="modal-header" style="background-color: #be0c4d;">
      <h5 style="color: white;">Ficha Análisis Información - General</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="row" style="margin: 5px;">
          <div class="col-2">
            <div *ngIf="MensualGeneral" class="row"><b>Periodo : Mes</b></div>
            <div *ngIf="TrimestralGeneral" class="row"><b>Periodo : Trimestre</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodo" [(ngModel)]="PeriodoFichaGeneral" disabled/></div>
          </div>
        </div>
        <button type="button" class="btn btn-success col-1" style="text-align: center; margin: 10px;" (click)="ExportarExcelFichaAnalisisGeneral()"><i class="fas fa-download"></i> Excel</button>
        <br>
        <nav id="FichaGeneralAnalisis">
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link active" id="nav-valdes-tab" data-bs-toggle="tab" data-bs-target="#nav-valdes" type="button" role="tab" aria-controls="nav-valdes" aria-selected="true" ><!--(click)="saldocaptotalgeneral()"-->
              <b style="color: black;">Valor Desembolsos</b>
            </button>
            <button class="nav-link" id="nav-numcre-tab" data-bs-toggle="tab" data-bs-target="#nav-numcre" type="button" role="tab" aria-controls="nav-numcre" aria-selected="false" ><!--(click)="saldovencidogeneral()"-->
              <b style="color: black;">Número de Créditos</b>
            </button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-valdes" role="tabpanel" aria-labelledby="nav-valdes-tab">
            <div class="accordion accordion-flush" id="accordionFlush1">
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo12valdes">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo12valdes" aria-expanded="false" aria-controls="flush-tipo12valdes">
                    1. Operación financiera opción 1 Y 2
                  </button>
                </h2>
                <div id="flush-tipo12valdes" class="accordion-collapse collapse show" aria-labelledby="flush-tipo12valdes" data-bs-parent="#accordionFlush1">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan12" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila1 of FGTablaOperFin12ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.concepto}}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.variacionmensual}}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.variacionanual}}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo1valdes">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1valdes" aria-expanded="false" aria-controls="flush-tipo1valdes">
                    2. Operación financiera opción 1
                  </button>
                </h2>
                <div id="flush-tipo1valdes" class="accordion-collapse collapse" aria-labelledby="flush-tipo1valdes" data-bs-parent="#accordionFlush1">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan1" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila2 of FGTablaOperFin1ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.concepto}}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.variacionmensual}}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12||Fila2.id==15"><b>{{Fila2.variacionanual}}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12&&Fila2.id!=15">{{Fila2.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo2valdes">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo2valdes" aria-expanded="false" aria-controls="flush-tipo2valdes">
                    3. Operación financiera opción 2
                  </button>
                </h2>
                <div id="flush-tipo2valdes" class="accordion-collapse collapse" aria-labelledby="flush-tipo2valdes" data-bs-parent="#accordionFlush1">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan2" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila3 of FGTablaOperFin2ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.concepto}}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.variacionmensual}}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.variacionanual}}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo3valdes">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3valdes" aria-expanded="false" aria-controls="flush-tipo3valdes">
                    4. Operación financiera opción 3
                  </button>
                </h2>
                <div id="flush-tipo3valdes" class="accordion-collapse collapse" aria-labelledby="flush-tipo3valdes" data-bs-parent="#accordionFlush1">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan3" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila4 of FGTablaOperFin3ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.concepto}}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.variacionmensual}}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.variacionanual}}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo4valdes">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo4valdes" aria-expanded="false" aria-controls="flush-tipo4valdes">
                    5. Operación financiera opción 4
                  </button>
                </h2>
                <div id="flush-tipo4valdes" class="accordion-collapse collapse" aria-labelledby="flush-tipo4valdes" data-bs-parent="#accordionFlush1">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan4" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila5 of FGTablaOperFin4ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.concepto}}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.variacionmensual}}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.variacionanual}}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-numcre" role="tabpanel" aria-labelledby="nav-numcre-tab">
            <div class="accordion accordion-flush" id="accordionFlush2">
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo12numcre">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo12numcre" aria-expanded="false" aria-controls="flush-tipo12numcre">
                    1. Operación financiera opción 1 Y 2
                  </button>
                </h2>
                <div id="flush-tipo12numcre" class="accordion-collapse collapse show" aria-labelledby="flush-tipo12numcre" data-bs-parent="#accordionFlush2">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan12" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila6 of FGTablaOperFin12NumCre">
                            <td scope="col" style="text-align: end;">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.concepto}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.mesanterior}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.mesactual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.variacionmensual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.anioanterior}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.mesactual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.variacionanual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo1numcre">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1numcre" aria-expanded="false" aria-controls="flush-tipo1numcre">
                    2. Operación financiera opción 1
                  </button>
                </h2>
                <div id="flush-tipo1numcre" class="accordion-collapse collapse" aria-labelledby="flush-tipo1numcre" data-bs-parent="#accordionFlush2">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan1" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila7 of FGTablaOperFin1NumCre">
                            <td scope="col" style="text-align: end;">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.concepto}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.mesanterior}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.mesactual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.variacionmensual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.anioanterior}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.mesactual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.variacionanual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo2numcre">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo2numcre" aria-expanded="false" aria-controls="flush-tipo2numcre">
                    3. Operación financiera opción 2
                  </button>
                </h2>
                <div id="flush-tipo2numcre" class="accordion-collapse collapse" aria-labelledby="flush-tipo2numcre" data-bs-parent="#accordionFlush2">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan2" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila8 of FGTablaOperFin2NumCre">
                            <td scope="col" style="text-align: end;">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.concepto}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.mesanterior}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.mesactual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.variacionmensual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.anioanterior}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.mesactual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.variacionanual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo3numcre">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3numcre" aria-expanded="false" aria-controls="flush-tipo3numcre">
                    4. Operación financiera opción 3
                  </button>
                </h2>
                <div id="flush-tipo3numcre" class="accordion-collapse collapse" aria-labelledby="flush-tipo3numcre" data-bs-parent="#accordionFlush2">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan3" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila9 of FGTablaOperFin3NumCre">
                            <td scope="col" style="text-align: end;">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.concepto}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.mesanterior}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.mesactual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.variacionmensual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.anioanterior}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.mesactual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.variacionanual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo4numcre">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo4numcre" aria-expanded="false" aria-controls="flush-tipo4numcre">
                    5. Operación financiera opción 4
                  </button>
                </h2>
                <div id="flush-tipo4numcre" class="accordion-collapse collapse" aria-labelledby="flush-tipo4numcre" data-bs-parent="#accordionFlush2">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan4" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualGeneral">Variación mensual</div>
                              <div *ngIf="TrimestralGeneral">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila10 of FGTablaOperFin4NumCre">
                            <td scope="col" style="text-align: end;">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.concepto}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.mesanterior}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.mesactual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.variacionmensual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.anioanterior}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.mesactual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==2||Fila10.id==5"><b>{{Fila10.variacionanual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">Salir</button>
    </div>
  </div>
</div>
</div>

<!--MODAL PREGUNTA FICHA ANALISIS MENSUAL MENSUAL O TRIMESTRAL-->
<button class="btn btn-primary btn-sm" #OpenModalPreguntaFichaIndividual data-toggle="modal"  data-target="#modal-preguntaindividual" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-preguntaindividual" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modal" style="color: white;">Ficha de Analisis Individual</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #CloseModalPreguntaFichaIndividual>
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <div class="row" style="margin: auto;">
            <div class="col">
              <p>Desea que la <b>ficha de análisis individual</b> se formule con información: </p>
            </div>
          </div>
          <div class="row" style="margin: auto;">
            <div class="col">
              <div class="row">
                <div class="col-auto"><b>Mensual</b></div>
                <div class="col-auto"><input class="form-check-input" type="checkbox" id="men" [(ngModel)]="MensualIndividual" [disabled]="TrimestralIndividual"></div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto"><b>Trimestral</b></div>
                <div class="col-auto"><input class="form-check-input" type="checkbox" id="tri" [(ngModel)]="TrimestralIndividual"  [disabled]="MensualIndividual"></div><!---->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        <button type="button" class="btn btn-secondary" (click)="VerificarTipoInformacionFichaIndividual()">Aplicar</button>
      </div>
    </div>
  </div>
</div>

<!--FICHA DE ANALISIS INDIVIDUAL-->
<button class="btn btn-primary btn-sm" #OpenModalFichaIndividual data-toggle="modal"  data-target="#fichaindividial" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-fullscreen" id="fichaindividial" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
<div class="modal-dialog modal-fullscreen">
  <div class="modal-content">
    <div class="modal-header" style="background-color: #be0c4d;">
      <h5 style="color: white;">Ficha Análisis Iinformación</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" #CloseModalFichaIndividual (click)="ResetVariables()">
        <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="row" style="margin: 5px;">
          <div class="col-2">
            <div *ngIf="MensualIndividual" class="row"><b>Periodo : Mes</b></div>
            <div *ngIf="TrimestralIndividual" class="row"><b>Periodo : Trimestre</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodofichaind" [(ngModel)]="PeriodoFichaIndividual" disabled/></div>
          </div>
          <div class="col-2">
            <div class="row"><b>NIT</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nitfichaind" [(ngModel)]="FuenteFichaIndividual.nit" disabled/></div>
          </div>
          <div class="col-4">
            <div class="row"><b>Razón social</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="FuenteFichaIndividual.nombEntidad" disabled/></div>
          </div>
          <div class="col-4">
            <div class="row"><b>Novedad</b></div>
            <div class="row"><input class="form-control" type="text" name="Novedadfichaind" [(ngModel)]="NovedadFichaIndividual" disabled/></div>
          </div>
        </div>
        <div>
          <div class="row" style="margin: 5px;"><b>Observaciones novedad</b></div>
          <div class="row" style="margin: 5px;"><input class="form-control" type="text" name="Novedad" [(ngModel)]="EstadoInfomacionFuente.observacionFte" disabled/></div>
        </div>
        <div class="row">
          <button *ngIf="!TrimestralIndividual" type="button" class="btn btn-danger col-auto" style="text-align: center; margin: 10px;" (click)="VerCargue()" [disabled]="CertNoMovi">Ver Cargue</button>
          <button *ngIf="!TrimestralIndividual" type="button" class="btn btn-danger col-1" style="text-align: center; margin: 10px;" (click)="AprobarCargue()">Aprobar</button>
          <button type="button" class="btn btn-success col-1" style="text-align: center; margin: 10px;" (click)="ExportarExcelFichaAnalisisIndividual()" [disabled]="CertNoMovi"><i class="fas fa-download"></i> Excel</button>
        </div>
        <nav *ngIf="!VercargueFuente&&!AprobarcargueFuente">
          <div class="nav nav-tabs" id="nav-tab-fichaind" role="tablist">
            <button class="nav-link active" id="nav-valdes-tab-fichaind" data-bs-toggle="tab" data-bs-target="#nav-valdes-fichaind" type="button" role="tab" aria-controls="nav-valdes-fichaind" aria-selected="true" [disabled]="CertNoMovi"><!--(click)="saldocaptotalgeneral()"-->
              <b style="color: black;">Valor Desembolsos</b>
            </button>
            <button class="nav-link" id="nav-numcre-tab-fichaind" data-bs-toggle="tab" data-bs-target="#nav-numcre-fichaind" type="button" role="tab" aria-controls="nav-numcre-fichaind" aria-selected="false" [disabled]="CertNoMovi"><!--(click)="saldovencidogeneral()"-->
              <b style="color: black;">Número Créditos</b>
            </button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent" *ngIf="!VercargueFuente&&!AprobarcargueFuente&&!CertNoMovi">
          <div class="tab-pane fade show active" id="nav-valdes-fichaind" role="tabpanel" aria-labelledby="nav-valdes-tab-fichaind">
            <div class="accordion accordion-flush" id="accordionFlush5">
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo12valdes-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo12valdes-fichaind" aria-expanded="false" aria-controls="flush-tipo12valdes-fichaind">
                    1. Operación financiera opción 1 y 2
                  </button>
                </h2>
                <div id="flush-tipo12valdes-fichaind" class="accordion-collapse collapse show" aria-labelledby="flush-tipo12valdes-fichaind" data-bs-parent="#accordionFlush5">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan12-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila1 of FITablaOperFin12ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.concepto}}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.variacionmensual}}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila1.id==1||Fila1.id==6||Fila1.id==9||Fila1.id==12"><b>{{Fila1.variacionanual}}</b></div>
                              <div *ngIf="Fila1.id!=1&&Fila1.id!=6&&Fila1.id!=9&&Fila1.id!=12">{{Fila1.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo1valdes-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1valdes-fichaind" aria-expanded="false" aria-controls="flush-tipo1valdes-fichaind">
                    2. Operación financiera opción 1
                  </button>
                </h2>
                <div id="flush-tipo1valdes-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo1valdes-fichaind" data-bs-parent="#accordionFlush5">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan1-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila2 of FITablaOperFin1ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.concepto}}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.variacionmensual}}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila2.id==1||Fila2.id==6||Fila2.id==9||Fila2.id==12"><b>{{Fila2.variacionanual}}</b></div>
                              <div *ngIf="Fila2.id!=1&&Fila2.id!=6&&Fila2.id!=9&&Fila2.id!=12">{{Fila2.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo2valdes-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo2valdes-fichaind" aria-expanded="false" aria-controls="flush-tipo2valdes-fichaind">
                    3. Operación financiera opción 2
                  </button>
                </h2>
                <div id="flush-tipo2valdes-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo2valdes-fichaind" data-bs-parent="#accordionFlush5">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan2-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila3 of FITablaOperFin2ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.concepto}}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.variacionmensual}}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila3.id==1||Fila3.id==6||Fila3.id==9||Fila3.id==12"><b>{{Fila3.variacionanual}}</b></div>
                              <div *ngIf="Fila3.id!=1&&Fila3.id!=6&&Fila3.id!=9&&Fila3.id!=12">{{Fila3.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo3valdes-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3valdes-fichaind" aria-expanded="false" aria-controls="flush-tipo3valdes-fichaind">
                    4. Operación financiera opción 3
                  </button>
                </h2>
                <div id="flush-tipo3valdes-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo3valdes-fichaind" data-bs-parent="#accordionFlush5">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan3-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila4 of FITablaOperFin3ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.concepto}}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.variacionmensual}}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila4.id==1"><b>{{Fila4.variacionanual}}</b></div>
                              <div *ngIf="Fila4.id!=1">{{Fila4.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo4valdes-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo4valdes-fichaind" aria-expanded="false" aria-controls="flush-tipo4valdes-fichaind">
                    5. Operación financiera opción 4
                  </button>
                </h2>
                <div id="flush-tipo4valdes-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo4valdes-fichaind" data-bs-parent="#accordionFlush5">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaValDesemOperFinan4-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila5 of FITablaOperFin4ValDes">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.concepto}}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.mesanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.mesanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.variacionmensual}}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.anioanterior  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.anioanterior  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.mesactual  | currency: 'USD' | lowercase }}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.mesactual  | currency: 'USD' | lowercase }}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila5.id==1||Fila5.id==2||Fila5.id==5"><b>{{Fila5.variacionanual}}</b></div>
                              <div *ngIf="Fila5.id!=1&&Fila5.id!=2&&Fila5.id!=5">{{Fila5.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-numcre-fichaind" role="tabpanel" aria-labelledby="nav-numcre-tab-fichaind">
            <div class="accordion accordion-flush" id="accordionFlush6">
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo12numcre-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo12numcre-fichaind" aria-expanded="false" aria-controls="flush-tipo12numcre-fichaind">
                    1. Operación financiera opción 1 y 2
                  </button>
                </h2>
                <div id="flush-tipo12numcre-fichaind" class="accordion-collapse collapse show" aria-labelledby="flush-tipo12numcre-fichaind" data-bs-parent="#accordionFlush6">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan12-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila6 of FITablaOperFin12NumCre">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.concepto}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.mesanterior}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.mesactual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.variacionmensual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.anioanterior}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.mesactual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila6.id==1||Fila6.id==6||Fila6.id==9||Fila6.id==12"><b>{{Fila6.variacionanual}}</b></div>
                              <div *ngIf="Fila6.id!=1&&Fila6.id!=6&&Fila6.id!=9&&Fila6.id!=12">{{Fila6.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo1numcre-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1numcre-fichaind" aria-expanded="false" aria-controls="flush-tipo1numcre-fichaind">
                    2. Operación financiera opción 1
                  </button>
                </h2>
                <div id="flush-tipo1numcre-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo1numcre-fichaind" data-bs-parent="#accordionFlush6">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan1-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila7 of FITablaOperFin1NumCre">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.concepto}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.mesanterior}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.mesactual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.variacionmensual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.anioanterior}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.mesactual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila7.id==1||Fila7.id==6||Fila7.id==9||Fila7.id==12"><b>{{Fila7.variacionanual}}</b></div>
                              <div *ngIf="Fila7.id!=1&&Fila7.id!=6&&Fila7.id!=9&&Fila7.id!=12">{{Fila7.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo2numcre-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo2numcre-fichaind" aria-expanded="false" aria-controls="flush-tipo2numcre-fichaind">
                    3. Operación financiera opción 2
                  </button>
                </h2>
                <div id="flush-tipo2numcre-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo2numcre-fichaind" data-bs-parent="#accordionFlush6">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan2-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila8 of FITablaOperFin2NumCre">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.concepto}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.mesanterior}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.mesactual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.variacionmensual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.anioanterior}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.mesactual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila8.id==1||Fila8.id==6||Fila8.id==9||Fila8.id==12"><b>{{Fila8.variacionanual}}</b></div>
                              <div *ngIf="Fila8.id!=1&&Fila8.id!=6&&Fila8.id!=9&&Fila8.id!=12">{{Fila8.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo3numcre-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3numcre-fichaind" aria-expanded="false" aria-controls="flush-tipo3numcre-fichaind">
                    4. Operación financiera opción 3
                  </button>
                </h2>
                <div id="flush-tipo3numcre-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo3numcre-fichaind" data-bs-parent="#accordionFlush6">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan3-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila9 of FITablaOperFin3NumCre">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.concepto}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.mesanterior}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.mesactual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.variacionmensual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.anioanterior}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.mesactual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila9.id==1"><b>{{Fila9.variacionanual}}</b></div>
                              <div *ngIf="Fila9.id!=1">{{Fila9.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-tipo4numcre-fichaind">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo4numcre-fichaind" aria-expanded="false" aria-controls="flush-tipo4numcre-fichaind">
                    5. Operación financiera opción 4
                  </button>
                </h2>
                <div id="flush-tipo4numcre-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo4numcre-fichaind" data-bs-parent="#accordionFlush6">
                  <div class="accordion-body">
                    <div class="container-fluid overflow-scroll" style="text-align: center;">
                      <table class="table table-bordered" id="TablaNumerCrediOperFinan4-fichaInd" style="margin: auto;">
                        <thead style="background-color: lightgray;">
                          <tr>
                            <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                            <th scope="col" class="text-center" colspan="3">
                              <div *ngIf="MensualIndividual">Variación mensual</div>
                              <div *ngIf="TrimestralIndividual">Variación trimestral</div>
                            </th>
                            <th scope="col" class="text-center" colspan="3">Variación anual</th>
                          </tr>
                          <tr>
                            <th class="text-center">{{PeriodoCol1}}</th>
                            <th class="text-center">{{PeriodoCol2}}</th>
                            <th class="text-center">% Variación</th>
                            <th class="text-center">{{PeriodoCol4}}</th>
                            <th class="text-center">{{PeriodoCol5}}</th>
                            <th class="text-center">% Variación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let Fila10 of FITablaOperFin4NumCre">
                            <td scope="col" style="text-align: end;" >
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.concepto}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.concepto}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.mesanterior}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.mesanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.mesactual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.variacionmensual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.variacionmensual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.anioanterior}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.anioanterior}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.mesactual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.mesactual}}</div>
                            </td>
                            <td scope="col">
                              <div *ngIf="Fila10.id==1||Fila10.id==5||Fila10.id==5"><b>{{Fila10.variacionanual}}</b></div>
                              <div *ngIf="Fila10.id!=1&&Fila10.id!=2&&Fila10.id!=5">{{Fila10.variacionanual}}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="CertNoMovi">
          <br>
          <br>
        </div>
        <div *ngIf="VercargueFuente" style="text-align: center;">
          <div class="overflow-scroll" style="max-width: auto; max-height: 600px;">
            <div class="row">
              <button type="button" class="btn btn-outline-success col-1" style="margin-left: 20px;margin-bottom: 5px;" (click)="DescargarCargueMasivo()">
                <i class='fas fa-file-excel fa-lg'></i> Excel
              </button>
              <br>
              <table class="table table-bordered" id="TablaConsultaReporte-FichaInd" style="margin: auto;">
                <thead style="background-color: lightgray;">
                  <tr>
                    <th class="text-center">Consecutivo</th>
                    <th class="text-center">Anio</th>
                    <th class="text-center">Mes</th>
                    <th class="text-center">Operación Financiera</th>
                    <th class="text-center">Sexo Titular</th>
                    <th class="text-center">Edad Titular</th>
                    <th class="text-center">Destino Crédito</th>
                    <th class="text-center">Solución Vivienda</th>
                    <th class="text-center">Destino Crédito Vivienda</th>
                    <th class="text-center">Destino Crédito Construcción</th>
                    <th class="text-center">Departamento</th>
                    <th class="text-center">Municipio</th>
                    <th class="text-center">Departamento Vivienda</th>
                    <th class="text-center">Municipio Vivienda</th>
                    <th class="text-center">Subsidio</th>
                    <th class="text-center">Tipo Subsidio</th>
                    <th class="text-center">Moneda</th>
                    <th class="text-center">Rango Vivienda</th>
                    <th class="text-center">Número Créditos</th>
                    <th class="text-center">Valor Avaluo</th>
                    <th class="text-center">Número Desembolsos</th>
                    <th class="text-center">Valor Crédito</th>
                    <th class="text-center">Plazo Crédito</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let R of ResultadoConsulta">
                    <td scope="col" style="text-align: center;">{{R.consecutivo}}</td>
                    <td scope="col" style="text-align: center;">{{R.anio}}</td>
                    <td scope="col" style="text-align: center;">{{R.mes}}</td>
                    <td scope="col" style="text-align: center;">{{R.cod_oper_fin}}</td>
                    <td scope="col" style="text-align: center;">{{R.sexo_TITULAR}}</td>
                    <td scope="col" style="text-align: center;">{{R.edad_titular}}</td>
                    <td scope="col" style="text-align: center;">{{R.des_cre}}</td>
                    <td scope="col" style="text-align: center;">{{R.solu_viv}}</td>
                    <td scope="col" style="text-align: center;">{{R.des_cre_vivi}}</td>
                    <td scope="col" style="text-align: center;">{{R.des_cre_cons}}</td>
                    <td scope="col" style="text-align: center;">{{R.depto}}</td>
                    <td scope="col" style="text-align: center;">{{R.municipio}}</td>
                    <td scope="col" style="text-align: center;">{{R.cod_dept_viv}}</td>
                    <td scope="col" style="text-align: center;">{{R.cod_mun_viv}}</td>
                    <td scope="col" style="text-align: center;">{{R.sub_sn}}</td>
                    <td scope="col" style="text-align: center;">{{R.tip_sub}}</td>
                    <td scope="col" style="text-align: center;">{{R.moneda}}</td>
                    <td scope="col" style="text-align: center;">{{R.ran_viv}}</td>
                    <td scope="col" style="text-align: center;">{{R.num_cred}}</td>
                    <td scope="col" style="text-align: center;">{{R.val_avaluo}}</td>
                    <td scope="col" style="text-align: center;">{{R.num_desem}}</td>
                    <td scope="col" style="text-align: center;">{{R.val_cred}}</td>
                    <td scope="col" style="text-align: center;">{{R.plaz_cred}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div *ngIf="AprobarcargueFuente">
          <div class="card">
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Observaciones para aprobar el cargue de información</b>
            </div>
            <br>
            <div style="text-align: center;">
              <textarea class="form-control col-10" name="observacionaprobador" rows="4" maxlength="255" style="margin: auto;" [(ngModel)]="EstadoInfomacionFuente.observacionSis" [disabled]="BtnAprobar"></textarea>
              <button type="button" class="btn btn-secondary col-auto" style="text-align: center; margin: 10px;" (click)="GuardarAprobacion()" [disabled]="BtnAprobar">Aprobar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">Salir</button>
    </div>
  </div>
</div>
</div>
